import { User } from "./user";
import { EUserType } from "../enum/e-user-type";
import { Observable } from "rxjs";
import { Package } from "../../packages/models/package";
import { Injector } from "@angular/core";
import { Subscription } from "../../subscription/models/subscription";

export class UserEleve extends User  {

  discriminator: EUserType = EUserType.Eleve;
  colorCode : string;
  isActiveDate : Date;

  constructor(public injector: Injector) {
    super(injector);
    this.colorCode = "";
  }

  public getPackage(): Observable<Package[]> {
    throw new Error("Method not implemented.");
  }

  public getSubscriptions(): Observable<Subscription[]> {
    throw new Error("Method not implemented.");
  }

}
